import { unreadCount as unreadNewsCounter } from '@/restapi/news/news.js';
import { unreadCount as unreadNotifyCount } from '@/restapi/notify.js';
import { computed } from 'vue';

export default {
    data() {
        return {
            newsModalOpen: false,
            unreadNewsCount: null,
            unreadNotifyCount: null,
        };
    },
    provide() {
        return {
            unreadNotifyCount: computed(() => this.unreadNotifyCount),
            unreadNewsCount: computed(() => this.unreadNewsCount),
            updateUnreadCounter: this.updateUnreadCounter,
        };
    },
    computed: {
        unreadCounter() {
            return this.unreadNewsCount + this.unreadNotifyCount;
        },
    },
    created() {
        this.updateUnreadCounter();
    },
    activated() {
        this.updateUnreadCounter();
    },
    methods: {
        async updateUnreadCounter() {
            this.unreadNewsCount = await unreadNewsCounter();
            this.unreadNotifyCount = await unreadNotifyCount();
        },
        openNews() {
            this.$refs.newsModal.open();
            this.newsModalOpen = true;

            // метрика
            try {
                this.$metrika.hit('notifications');
            } catch (e) {
                console.error('Не удалось отправить метрику: ' + e);
            }
        },
        async closeNews() {
            await this.$refs.newsModal.close();
            this.newsModalOpen = false;
            this.updateUnreadCounter();
        },
    },
};
